<template>
    <div v-show="largeModal" style="font-family: Hind Siliguri Light " size="md" class="modal-window">
        <div class="modal-content">
            <div style="border-bottom:1px solid #bbc3ca" class="container">
                <div class="row">
                    <div class="col-md-6">
                        <span class="pull-left"><b>অফিসে পানির নতুন সংযোগের আবেদন ফরম</b></span>
                    </div>
                    <div class="col-md-6">
                        <span @click="close()" style="cursor:pointer" class="pull-right"><b><i class="fa fa-times"></i></b></span>
                    </div>
                </div>
                <div style="width:100%;height:10px;"></div>
            </div>
            <div class="container pt-2">

            <form @submit.prevent="addApplication">
                <div class="container custom_modal_body">
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">মোবাইল নম্বর</label>
                        <div class="col-sm-4">
                            <input type="text" disabled v-validate="'required'" v-model="user.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                        </div>
                        <label  class="col-sm-2 col-form-label">অফিসের নাম</label>
                        <div class="col-sm-4">
                            <input type="text" disabled v-validate="'required'" v-model="user.name" class="form-control" name="name" placeholder="অফিসের নাম">
                        </div>
                    </div>
                    <div  class="form-group row">
                        <label  class="col-sm-2 col-form-label">অফিসের ধরন</label>
                        <div class="col-sm-4">
                            <input type="text" name="ofc_type" disabled v-model="user.ofc_type" class="form-control" placeholder="অফিসের ধরন">
                        </div>
                        <label class="col-sm-2 col-form-label">ঠিকানা</label>
                        <div class="col-sm-4">
                            <input type="text" name="ofc_address" disabled v-validate="'required'" v-model="user.ofc_address" class="form-control"  placeholder="ঠিকানা">
                        </div>
                    </div>

                    <div  class="form-group row">
                        <label class="col-sm-2 col-form-label">ওয়ার্ড নং <span class="required">*</span></label>
                        <div class="col-sm-4">
                            <select v-validate="'required'" v-model="application.ward_no" name="ward_no" class="form-control">
                                <option value="">ওয়ার্ড নং</option>
                                <option :value="ward.id" v-for="(ward,key) in wards" :key="key">{{ward.ward_name_bng}}</option>
                            </select>
                            <p v-show="errors.has('ward_no')"  style="color:red">* {{ errors.first('ward_no') }}</p>
                        </div>
                        <label class="col-sm-2 col-form-label">লাইনের ধরন <span class="required">*</span></label>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-6 pr-1">
                                    <select v-validate="'required'" @change="getSelectService()" v-model="select_dia"  class="form-control">
                                        <option value="">লাইনের ব্যাস</option>
                                        <option value="0.5">0.5 ইঞ্চি</option>
                                        <option value="0.75">0.75 ইঞ্চি</option>
                                        <option value="1.00">1 ইঞ্চি</option>
                                        <option value="1.5">1.5 ইঞ্চি</option>
                                        <option value="2">2 ইঞ্চি</option>
                                    </select>
                                </div>
                                <div class="col-6 pl-1">
                                    <select v-validate="'required'" @change="serviceCharge()" v-model="application.service_id" name="Diameter" class="form-control">
                                        <option value="">লাইনের ধরন</option>
                                        <option :value="diameter.id" v-for="(diameter,key) in service_list" :key="key">{{diameter.name}}&nbsp;{{diameter.diameter}} ইঞ্চি</option>
                                    </select>
                                    <p v-show="errors.has('Diameter')"  style="color:red">* Required field</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">অনুমোদন পেপার <span class="required">*</span></label>
                        <div class="col-sm-4">
                            <input
                                name="document"
                                v-validate="'image|required|size:2048'"
                                type="file"
                                class="file-input"
                                v-on:change="imageChanged"
                            />
                            <p v-show="errors.has('document')"  style="color:red">* {{ errors.first('document') }}</p>
                        </div>
                        <label class="col-sm-2 col-form-label">অ্যাডজাস্টমেন্ট</label>
                        <div class="col-sm-2 pr-1">
                            <select @change="adjust(question)" v-model="adjustment_type" class="form-control">
                                <option value="">প্রকার</option>
                                <option value="1">অতিরিক্ত ফি</option>
                                <option value="2">কম ফি</option>
                            </select>
                        </div>
                        <div class="col-sm-2 pl-1">
                            <input  type="number" v-model="question" min="0"  class="form-control">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div style="border-top:1px solid #bbc3ca" class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-6">

                                </div>
                                <div class="col-sm-6">
                                    <div class="row mt-1">
                                        <div class="col-sm-6">সংযোগ ফি</div><div class="col-sm-6">: <b>{{application_fee}}</b></div>
                                        <div class="col-sm-6">অ্যাডজাস্টমেন্ট</div><div class="col-sm-6">: <b>{{application.adjustment}}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6"></div>
                        <div style="border-top:1px solid #bbc3ca" class="col-sm-6">
                            <div class="row mt-1">
                                <div class="col-sm-6">মোট সংযোগ ফি</div><div class="col-sm-6">: <b>{{application.fee}}</b></div>
                                <div class="col-sm-6">মাসিক বিল</div><div class="col-sm-6">: <b>{{application.monthly_bill}}</b></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                    <input type="submit" value="submit" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="!addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_APPLICATION,UPDATE_APPLICATION} from "@/store/action.type"
export default {
    data(){
        return{
            question:0,
            servererrors:{},
            addApplicationLoader:false,
            index:'',
            largeModal:false,
            holdings:[],
            diameter_list:[],
            check:false,
            user:{
                id:'',
                name:'',
                ofc_address:'',
                mobile_number:'',
                ofc_type:''
            },
            application_fee:0,
            application:{
                connection_fee:0,
                name:'',
                fathers_or_husband_name:'',
                road_name:'',
                mothers_name:'',
                moholla_name:'',
                home_type:'',
                ward_no:'',
                imarat_number:'',
                family_number:'',
                water_line_change_reason:'',
                previous_water_line_number:'',
                previous_bill_due:'',
                paura_tax:'',
                tax_pay_date:'',
                applicant_picture:'',
                applicant_sign:'',
                word_counsil_comment:'',
                fee:0,
                monthly_bill:0,
                adjustment:0,
                holding_id:'',
                service_id:'',
                adjustment_type:'',
                holding_name:'',
                type:'new-water-ofc-connection',
                file:'',
                not_edit_file:11
            },
            adjustment_type:'',
            service_list:[],
            select_dia:''
        }
    },
    watch:{
        question: function (){
            this.application.adjustment = parseInt(this.question)
            this.adjust(parseInt(this.question))
        }
    },
    methods:{
        getSelectService(){
            this.application.service_id = ''
            this.service_list = []
            this.diameter_list.forEach(element=>{
                if(element.diameter == parseFloat(this.select_dia) && element.type == 3){
                    this.service_list.push(element)
                }
            })
        },
        newHoldingAdd(){
            this.$emit('addHolding',this.user);
        },
        pushHolding(holding){
            this.holdings.push(holding)
        },
        imageChanged(e) {
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = e => {
                this.application.file = e.target.result
                this.application.not_edit_file = 11
            }
        },
        pictureChanged(e) {
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = e => {
                this.application.applicant_picture = e.target.result
            }
        },
        signChanged(e){
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = e => {
                this.application.applicant_sign = e.target.result
            }
        },
        getHoldingName(){
            var self = this
            this.holdings.forEach(element=>{
                if(element.id == self.application.holding_id){
                    self.application.holding_name = element.name ? element.name : element.bn_name
                }
            })
        },
        adjust(adjustment = 0){
            this.application.adjustment =  adjustment
            var self = this
            //alert(self.adjustment_type)
            if(self.adjustment_type){
                if(self.adjustment_type == 1){
                    self.application.adjustment =  parseInt(self.application.adjustment)
                    self.application.adjustment_type = 'positive'
                }
                else if(self.adjustment_type == 2){
                    self.application.adjustment =  parseInt(-self.application.adjustment)
                    self.application.adjustment_type = 'negative'
                }
            }
            else{
                self.application.adjustment =  0
                self.application.adjustment_type = 'positive'
            }

            //self.application.fee = parseInt(self.application.connection_fee) + parseInt(self.application.adjustment)
            //self.application.fee = self.application_fee + self.application.adjustment
            self.application.fee = parseInt(self.application_fee) + parseInt(self.application.adjustment)

            //alert(self.application.fee)
        },
        serviceCharge(){
            var self = this

            this.diameter_list.forEach(element=>{
                if(element.id == self.application.service_id){
                    self.application_fee = element.connection_fee
                    self.application.fee = self.application_fee + self.application.adjustment
                    self.application.monthly_bill = element.price
                }
            })
        },
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        addApplication () {
            //console.log(this.application)
            if(this.$user.type !=1){
                this.application.file = true
                this.application.not_edit_file = 10
            }
            this.check = true
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.check = false
                    this.application.user_id = this.user.id;
                    var data = this.application
                    this.addApplicationLoader = true;
                    this.$store.dispatch('ADD_APPLICATION',data)
                    .then(response=>{
                        this.addApplicationLoader = false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addApplicationLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })

        },
        openModal(user_data){
            console.log(user_data)
            this.question = 0
            this.application.fee = 0
            this.application.monthly_bill = 0
            this.application.adjustment = 0
            this.application.holding_id = ''
            this.application.service_id = ''
            this.application.adjustment_type = ''
            this.application.holding_name = ''
            this.adjustment_type = ''

            this.check = false
            this.application.file = ''
            this.index = ''
            this.largeModal = true
            this.user = user_data.user
            this.holdings = user_data.holding
            this.diameter_list = user_data.project
        },
    },
    computed:{
        ...mapGetters(["wards"])
    },

}
</script>

<style scoped>
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
.custom_modal_body{
    overflow: auto;
    min-height: 338px;
    overflow-x: hidden;
}
.modal-window{
        position: fixed;
        z-index: 9999;
        padding-top: 50px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal-content{
        position: fixed;
        z-index: 9999;
        padding-top: 15px;
        left: 15%;
        top: 10%;
        width:70%;
         height:80%;
        overflow: auto;
        background-color:#fff;
    }
    .pt-2{
        padding-top:20px !important;
    }
    .required{
        color: red;
    }
</style>
